import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { useAuthStore } from '../store/authStore'

export interface UserLocation {
  location_id: string
  location_name: string
}

/**
 * Returns the current user's accessible location IDs.
 * - undefined while loading
 * - null     → unrestricted (Owner / Admin / super_admin, or no restrictions set)
 * - string[] → restricted to these locations only
 */
export function useUserLocationIds() {
  const { user, tenant } = useAuthStore()
  const uid = user?.id ?? ''
  const tid = tenant?.id ?? ''

  return useQuery<string[] | null>({
    queryKey: ['user-location-ids', tid, uid],
    enabled: !!uid && !!tid,
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any).rpc('get_user_location_ids')
      if (error) throw error
      return (data as string[] | null) ?? null
    },
    staleTime: 5 * 60 * 1000,
  })
}
